import { TruncatableText } from '@/components/molecules/TruncatableText/TruncatableText'
import classNames from 'classnames'

type PageTitleProps = React.PropsWithChildren & {
    label: string
    labelTestId: string
    className?: string
}

export const PageTitle: React.FC<PageTitleProps> = ({
    label,
    labelTestId,
    className,
}) => {
    const computedClassName = classNames('text-heading-4 px-6 py-1', className)
    return (
        <div className={computedClassName} data-testid={labelTestId}>
            <TruncatableText
                text={label}
                tooltipClassname="max-w-tooltipWidth"
            />
        </div>
    )
}
